<template>
    <v-container>
        <div v-if="!loading">
            <v-row class="my-2 subtitle-2 secondary--text pl-12">
                Games
            </v-row>
            <v-divider /> 
            <v-row justify="start" class="mt-4 ml-4">
                <!--add new game -->
                <v-btn color="secondary" class="text-lowercase" 
                    dark small to="/professor/create">
                    create game
                </v-btn>
            </v-row>
            <div v-if="games.length">
                <!--table head-->
                <v-row class="subtitle-2" no-gutters>
                    <v-col v-for="(item, index) in headers" :key="index">{{ item }}</v-col>
                </v-row>
                <!--games table -->
                <v-row 
                    v-for="game in games" :key="game.id">
                    <v-col>{{ game.id }}</v-col>
                    <v-col>{{ dateToString(game.createdAt) }}</v-col>
                    <v-col>{{ game.round }}</v-col>
                    <v-col>{{ game.description }}</v-col>
                </v-row>
               
            </div>
            <v-row v-else>
                You didn't create any game yet
            </v-row>
        </div>
        <div v-else>
            <loader></loader>
        </div>
    </v-container>
</template>

<script>
import Loader from '../../layouts/Loader.vue'
//import Update from '../components/editGame.vue'

import { ConvertDateToString } from '../../functions/common';

export default {
    name: 'Games',
    data() {
        return {
            headers: ['game id', 'date of creation', 'current round', 'description'],
        }
    },
    computed: {
        games() {
            return this.$store.getters.games;
        },
        loading() {
            return this.$store.getters.loading;
        },
        locale() {
            return this.$store.getters.locale;
        },
        loggedIn() {
            return this.$store.getters.loggedIn
        }
    },
    watch: {
        loggedIn() {
            if (!this.loggedIn) {
                this.$router.push('/home');
            }
        }
    },
    methods: {
        dateToString(date) {
            return ConvertDateToString(date, this.locale)
        }
    },
    components: {
        Loader
    },
    async created() {
        await this.$store.dispatch('fetchUserGames');
    }
}
</script>
